import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

/**
 * Import campaign coachable pages
 */
import {
  Landing,
  Loading,
  LessonDetails,
  BlogArticle,
  SwiperGame,
  Quiz,
  QuizFeedback,
  QuizResults,
  RecycleRIGHT,
  RcForKidsDetails
} from './pages';
import RecycleRIGHTGame from './pages/Landing/components/RecycleRIGHTGame';

/**
 * Public route constants
 */
const routeConsts = {
  lessonDetails: '/lesson-details',
  blogArticle: '/blog-article/:id',
  landing: '/landing',
  quiz: '/quiz/:type/:quizIndex',
  quizFeedback: '/quiz-feedback/:type',
  quizResults: '/quiz-results/:type',
  swiperGame: '/swiper-game',
  recycleRight: '/recycle-right',
  recycleRightInitial: '/recycle-right-initial',
  rcForKidsDetails: '/rc-for-kids'
};

/**
 * Root router component
 */
const Routes = () => {
  const {
    lessonDetails,
    blogArticle,
    landing,
    quiz,
    quizFeedback,
    quizResults,
    swiperGame,
    recycleRight,
    recycleRightInitial,
    rcForKidsDetails
  } = routeConsts;

  return (
    <Router>
      <Switch>
        <Route
          path={lessonDetails}
          key={Math.floor(Math.random() * 100)}
          render={() => <LessonDetails />}
        />
        <Route
          path={blogArticle}
          render={() => <BlogArticle />}
        />
        <Route
          path={landing}
          render={() => <Landing />}
        />
        <Route
          path={quiz}
          key={Math.floor(Math.random() * 100)}
          render={() => <Quiz />}
        />
        <Route
          path={quizFeedback}
          render={() => <QuizFeedback />}
        />
        <Route
          path={quizResults}
          render={() => <QuizResults />}
        />
        <Route
          path={swiperGame}
          render={() => <SwiperGame />}
        />
        <Route
          path={recycleRight}
          render={() => <RecycleRIGHT />}
        />
        <Route
          path={recycleRightInitial}
          render={() => <RecycleRIGHTGame />}
        />
        <Route
          path={rcForKidsDetails}
          render={() => <RcForKidsDetails />}
        />
        <Route
          path="/"
          render={() => <Loading />}
        />
      </Switch>
    </Router>
  );
};

export default Routes;
